//#region src/menu_item_view_details_style.ts
let MenuItemViewDetailsStyle = /* @__PURE__ */ function(MenuItemViewDetailsStyle) {
	MenuItemViewDetailsStyle["Default"] = "default";
	MenuItemViewDetailsStyle["Compact"] = "compact";
	return MenuItemViewDetailsStyle;
}({});
//#endregion
export { MenuItemViewDetailsStyle };

//# sourceMappingURL=menu_item_view_details_style.js.map